import { render, staticRenderFns } from "./FormOrganisationLocaleIntroduction.vue?vue&type=template&id=88818aee&scoped=true&"
import script from "./FormOrganisationLocaleIntroduction.vue?vue&type=script&lang=js&"
export * from "./FormOrganisationLocaleIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88818aee",
  null
  
)

export default component.exports